import { Routes, Route, BrowserRouter } from "react-router-dom";

import IntroScreen from "./components/screens/IntroScreen";
import SadScreen from "./components/screens/SadScreen";
import SuccessScreen from "./components/screens/SuccessScreen";
import TeddyScreen from "./components/screens/TeddyScreen";
import LetterScreen from "./components/screens/LetterScreen";
import ChocolateScreen from "./components/screens/ChocolateScreen";
import SurpriseScreen from "./components/screens/SurpriseScreen";
import CardMemories from "./components/screens/CardMemories";
import Note from "./components/screens/BookScreen";

const AppRoutes = () => {
  return (
    <BrowserRouter basename="/i/love/you/sakhi">
      <Routes>
        <Route path="/" element={<IntroScreen />} />
        <Route path="/sad" element={<SadScreen />} />
        <Route path="/success" element={<SuccessScreen />} />
        <Route path="/teddy" element={<TeddyScreen />} />
        <Route path="/letter" element={<LetterScreen />} />
        <Route path="/chocolate" element={<ChocolateScreen />} />
        <Route path="/surprise" element={<SurpriseScreen />} />
        <Route path="/memories" element={<CardMemories />} />
        <Route path="/lovebook" element={<Note />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
